<div class="container-fluid">
  <h1 translate>login.title</h1>
  <br>
  <h3>
    {{ 'login.note_on_website_usage0' | translate}}
    <br>
    <br>
    {{ 'login.note_on_website_usage1' | translate}}
    <br>
    {{ 'login.note_on_website_usage2' | translate}}
  </h3>
  <form class="login-form" [formGroup]="loginForm">
    <div *ngIf="showLoginAlert" class="alert alert-danger" role="alert" translate>
      login.incorrect
    </div>
    <div *ngIf="!showLoginAlert" class="invisible alert alert-danger" role="alert"></div>
    <br>
    <mat-form-field>
      <input [placeholder]="'placeholder.username' | translate" formControlName="username" matInput name="email"
        type="email">
    </mat-form-field>
    <mat-form-field>
      <input [placeholder]="'placeholder.password' | translate" formControlName="password" matInput name="password"
        type="password">
    </mat-form-field>

    <div class="controls-wrapper row">
      <div class="col">
        <button (click)="login()" [disabled]="loginForm.invalid" color="primary" mat-flat-button>{{'login.sign_in' |
          translate}}</button>&nbsp;&nbsp;
      </div>
    </div>
    <br>
    <div class="controls-wrapper row">
      <div class="col">
        <a class="btn btn-primary" [href]="'https://pickwings.ch/' + _translate.currentLang + '/transport-partner/signup'" class="small" translate>{{'login.register' |
          translate}}</a>
      </div>
    </div>

    <div class="controls-wrapper row">
      <div class="col">
        <a [routerLink]="[]" (click)="forgot_password()" class="small" translate>login.forgot_password</a>&nbsp;&nbsp;
      </div>
      <div class="col">
        <a href="https://pickwings.ch" class="small" translate>login.not_transport_partner_question</a>
      </div>
    </div>

  </form>

  <div class="api-trouble" *ngIf="!(health?.isHealthy$ | async)" translate>login.api_trouble</div>

  <p class="footer">&copy; {{versions.date | date : 'yyyy'}} {{'login.pickwings' | translate}}</p>

  <div class="version-wrapper" *ngIf="environment.isBuildInfoShown">
    <div class="version-source">webapp:</div>
    <div>{{ versions?.date | date: 'dd.MM.yyyy HH:mm:ss' }}</div>
    <div>
      <a href="https://gitlab.com/pickwings/webapps/-/tree/{{versions?.hash}}" target="_blank">{{versions?.hash}}</a>
    </div>
    <ng-container *ngIf="!!health?.healthInfo">
      <div>{{environment?.envName}}</div>
      <div class="version-source">api:</div>
      <div>{{ (health.healthInfo.build_date | date: 'dd.MM.yyyy HH:mm:ss') || ('common.invalid_date' | translate)}}
      </div>
      <div>
        <a href="https://gitlab.com/pickwings/pickwings-web-core/-/tree/{{health.healthInfo?.build_hash}}"
          target="_blank">{{health.healthInfo?.build_hash}}</a>
      </div>
      <div>{{health.healthInfo?.build_env}}</div>
    </ng-container>
  </div>
</div>

<pw-centered-spinner *ngIf="isLoading"></pw-centered-spinner>
<!-- <app-cookie-banner></app-cookie-banner> -->